import { Elements } from "@stripe/react-stripe-js";
import JetpackCheckoutForm, {
  type JetpackCheckoutParams
} from "./JetpackCheckoutForm";
import stripePromise from "../../../../components/stripePromise";
import React, { useMemo } from "react";
import { useUrlQuery } from "../../../../utils/hooks/useUrlQuery";

export default function CheckoutSubscription() {
  const query = useUrlQuery();

  const params = useMemo<JetpackCheckoutParams>(() => {
    return {
      isNew: query.get("isNew") === "true",
      simpleOnboarding: query.get("so") === "true",
      placeName: query.get("placeName"),
      planId: query.get("planId"),
      duration: query.get("duration"),
      commitment: query.get("commitment"),
      spc: query.get("spc"),
      sts: query.get("sts"),
      useSamePayment: query.get("useSamePayment"),
      copyFromAccount: query.get("copyFromAccount"),
      payment_intent: query.get("payment_intent"),
      payment_intent_client_secret: query.get("payment_intent_client_secret"),
      redirect_status: query.get("redirect_status"),
      setup_intent: query.get("setup_intent"),
      setup_intent_client_secret: query.get("setup_intent_client_secret")
    };
  }, [query]);

  return (
    <Elements stripe={stripePromise} options={options}>
      <JetpackCheckoutForm params={params} />
    </Elements>
  );
}

const options = {
  fonts: [
    {
      cssSrc:
        "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap"
    }
  ]
};
